let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1MLi2")).then(() => parcelRequire('bzIDF'));